import React, { useState } from 'react';
import { Modal } from '@/components/common/Modal';
import { Button } from '@/components/common/Button';
import { Input } from '@/components/common/Input';
import { Textarea } from '@/components/common/Textarea';
import { Task } from '@/types';
import { useTaskStore } from '@/store/taskStore';
import { formatCurrency } from '@/utils/helpers';
import { Check } from 'lucide-react';
import toast from 'react-hot-toast';
import { TASK_STATUS } from '@/utils/constants';

interface CreateQuotationModalProps {
  isOpen: boolean;
  onClose: () => void;
  task: Task;
}

export const CreateQuotationModal: React.FC<CreateQuotationModalProps> = ({
  isOpen,
  onClose,
  task
}) => {
    const { updateTask } = useTaskStore();
    const [quotationAmount, setQuotationAmount] = useState(task?.quotationAmount?.toString() || '');
    const [remarks, setRemarks] = useState(task?.remarks || '');
    const [loading, setLoading] = useState(false);
    
    console.log({ status: TASK_STATUS.PENDING, typeof: typeof TASK_STATUS.PENDING });

  const handleSave = async () => {
    if (!quotationAmount) {
      toast.error('Please enter quotation amount');
      return;
    }

    setLoading(true);
    try {
      await updateTask(task._id || task.id || '', {
        quotationAmount: parseFloat(quotationAmount),
        status:'Pending',
        // TASK_STATUS.PENDING,
        remarks
      });
      toast.success('Quotation saved successfully');
      onClose();
    } catch (error) {
      console.log('error: ', error);
      toast.error('Failed to save quotation');
    } finally {
      setLoading(false);
    }
  };

  const handleSaveAsDraft = async () => {
    setLoading(true);
    try {
      await updateTask(task._id || task.id || '', {
        quotationAmount: quotationAmount ? parseFloat(quotationAmount) : undefined,
        remarks
      });
      toast.success('Draft saved successfully');
      onClose();
    } catch (error) {
      toast.error('Failed to save draft');
    } finally {
      setLoading(false);
    }
  };

  const clientName = typeof task?.client === 'string' ? task?.client : task?.client?.name || 'Unknown Client';

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Create Quotation" size="sm">
      <div className="space-y-4 px-4">
        {/* Task Info */}
        <div className="bg-gray-50 p-3 border rounded-lg flex items-start space-x-3">
          <div className="mt-0.5 bg-gray-500">
            <Check className="w-4 h-4 text-white" />
          </div>
          <div className="flex-1">
            <p className="font-medium text-sm">
              {clientName} — {task?.task} — {task?.subTask}
            </p>
          </div>
        </div>

        {/* Quotation Amount */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Quotation Amount
          </label>
          <Input
            type="number"
            value={quotationAmount}
            onChange={(e) => setQuotationAmount(e.target.value)}
            placeholder="Enter amount"
            min="0"
            step="0.01"
          />
        </div>

        {/* Remarks */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Remarks
          </label>
          <Textarea
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="Enter any additional remarks..."
            rows={4}
          />
        </div>

        {/* Actions */}
        <div className="flex justify-between items-center pt-4">
          <Button
            variant="secondary"
            onClick={handleSaveAsDraft}
            disabled={loading}
          >
            Save as Draft
          </Button>
          
          <div className="flex space-x-3">
            <Button
              variant="secondary"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};